<template>
    <div class="container-fluid" style="background-color: white;">
        <!--submit-->
        <div class="row">
            <div class="col text-right">
                <button class="btn btn-default margin next" @click="goToBackWord">
                    <icon name="backward"></icon>
                    ย้อนกลับ
                </button>
                <button class="btn btn-default margin next" @click="goToForward">
                    <icon name="forward"></icon>
                    ถัดไป
                </button>
                <button class="btn btn-success margin"
                        @click="showConfirmModal">
                    <icon name="save"></icon>
                    บันทึกจบ
                </button>
                <button class="btn btn-danger margin" @click="goToEmployeeList">
                    <icon name="times"></icon>
                    ยกเลิก
                </button>
            </div>
        </div>
        <div class="row border border-dark">
            <div class="col-sm-12" style="padding: 20px">
                <h5>ข้อมูลส่วนบุคคล</h5>
                <div class="row form-inline form-group">
                    <div class="col-sm-4">
                        <label>ประเภทการลา<span style="color: red; font-weight: bold">*</span></label>
                    </div>
                    <div class="col-sm-4 form-group">
                        <input type="radio" value="0"
                               id="permission1"
                               v-model="form.status_leave"/>
                        <label for="permission1">ไม่มีสิทธ์ลา</label>
                    </div>
                    <div class="col-sm-4 form-group">
                        <input type="radio" value="1"
                               id="permission2"
                               v-model="form.status_leave"/>
                        <label for="permission2">มีสิทธ์ลา</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="row border border-dark" v-if="form.status_leave==1">
            <div class="col-sm-12">
                <br/>
                <h5>จำนวนวันลา</h5>
                <br/>
                <div class="col-sm-8 table-responsive">
                    <table class="table table-bordered">
                        <tr>
                            <td></td>
                            <td align="center">จำนวนวัน</td>
                            <td align="center">วันที่ใช้ไป</td>
                            <td align="center">วันคงเหลือ</td>
                        </tr>
                        <tr v-for="data in LeavingDay">
                            <td width="150px" class="text-right">{{data.name}}</td>
                            <td align="center">
                                {{data.total}}
                            </td>
                            <td align="center">
                                {{data.use}}
                            </td>
                            <td align="center">
                                {{data.balance}}
                            </td>
                        </tr>
                    </table>
                    <br/>
                </div>
            </div>
        </div>
        <!--<pre class="alert alert-danger text-left">{{form}}</pre>-->
        <b-modal hide-header hide-footer ref="confirmEmp">
            <confirm-emp-modal @submit="saveEmployee">
            </confirm-emp-modal>
        </b-modal>
    </div>
</template>

<script>
    import { mapState } from "vuex"
    import DatePicker from 'vue2-datepicker'
    import confirmEmpModal from "../../../Utility/ConfirmEmpModal";

    import {
        canViewSuperAdmin
    } from "../../../../util/Permissions";
    export default {
        name: "employee-leave-day",
        components : {confirmEmpModal},
        props: {
            status_bar: { default: false },
        },
        created(){
            this.$store.dispatch("Employee/setLeaveDayAll");
        },
        data(){
          return{

          }
        },
        computed:{
            canViewSuperAdmin,
            ...mapState({
                form:state =>{
                    return state.Employee.employeeForm;
                },
                leaveDay:state=>{
                    return state.Employee.leaveDayAll.filter(data=>data.id != 8 && data.id != 9);
                },
                user:state=>{
                    return state.Auth.user;
                },

            }),
            LeavingDay(){
                if(this.form.id){
                    if(this.form.leaving_day < 1){
                        if(this.form.occupation.employee_type == 1){
                            return this.leaveDay.map(data=>({
                                id : data.id,
                                name : data.name,
                                use : 0,
                                balance : data.how_long_month,
                                total : data.how_long_month
                            }));
                        }
                        else{
                            return this.leaveDay.map(data=>({
                                id : data.id,
                                name : data.name,
                                use : 0,
                                balance : data.how_long_day,
                                total : data.how_long_day
                            }));
                        }
                    }
                    return this.form.leaving_day
                }
                if(this.form.occupation.employee_type == 1){
                    return this.leaveDay.map(data=>({
                        id : data.id,
                        name : data.name,
                        use : 0,
                        balance : data.how_long_month,
                        total : data.how_long_month
                    }));
                }
                else{
                    return this.leaveDay.map(data=>({
                        id : data.id,
                        name : data.name,
                        use : 0,
                        balance : data.how_long_day,
                        total : data.how_long_day
                    }));
                }
            }
        },
        methods:{
            showConfirmModal(){
                this.$refs.confirmEmp.show();
            },
            goToEmployeeList(){
                this.$router.push({
                    name : "employee"
                })
            },
            goToBackWord(){
                this.$router.push({
                    name : "employee-social-insurance"
                })
            },
            goToForward(){
                if(this.validateData()){
                    this.$router.push({
                        name : "employee-information-tax"
                    })
                }
            },
            saveEmployee(value){
                if(value){
                    this.form.user_id = this.user.id;
                    if(this.validateData()){
                        this.$store.dispatch("Employee/saveEmployee",{
                            id : this.form.id,
                            data : this.form
                        });
                        this.goToEmployeeList();
                    }
                }else{
                    this.$refs.confirmEmp.hide();
                }
            },
            validateData(){
                this.form.leaving_day = [];
                const details = this.LeavingDay;
                if(!this.form.status_leave){
                    alert("กรุณาเลือกสิทธ์ในการลา")
                }
                else{
                    if(details.length > 0 && this.form.status_leave == 1){
                        details.forEach(data=>{
                            const detail = {
                                holiday_type_id : data.id,
                                name : data.name,
                                total : data.total,
                                use : data.use,
                                balance : data.balance
                            };
                            this.form.leaving_day.push(detail);
                        })
                    }
                    return true;
                }
            },
        }
    }
</script>

<style scoped>
    body {font-family: Arial, Helvetica, sans-serif;}
    * {box-sizing: border-box;}

    .form-inline {
        display: flex;
        flex-flow: row wrap;
        align-items: left;
    }

    .form-inline label {
        margin: 5px 10px 5px 0;
    }

    .form-inline input {
        vertical-align: middle;
        margin: 5px 10px 5px 0;
        padding: 10px;
        background-color: #fff;
        border: 1px solid #ddd;
    }

    .form-inline button {
        padding: 10px 20px;
        border: 1px solid #ddd;
        color: white;
        cursor: pointer;
    }

    .form-inline button:hover {

    }

    @media (max-width: 800px) {
        .form-inline input {
            margin: 10px 0;
        }
        .form-inline {
            flex-direction: column;
            align-items: stretch;
        }
    }
    .padding{
        padding: 20px;
    }
    .margin{
        margin: 10px;
    }
</style>
